export default __webpack_public_path__ + "static/media/462.4131cc6b.gif";